import React, { useEffect, useState, useRef } from 'react';
import Layout from '../../components/layout/Layout';
import { getData } from '../../services/apiService';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, 
    Typography, TextField, Select, MenuItem, Pagination, InputAdornment, InputLabel, FormControl
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Progress from '../../hooks/useProgressBar';
import useDebounce from '../../hooks/useDebounce';

const AuditLogDetails = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const isFetched = useRef(false);
    const [formData, setFormData] = useState({ role_name: "" });

    // Pagination and search states
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedRole, setSelectedRole] = useState('');
    const [roleData, setRoleData] = useState([]);

    useEffect(() => {
        if (!isFetched.current) {
            fetchData();
            getRoleDropdown();
        }
    }, [page, rowsPerPage, debouncedSearchQuery, selectedRole]);

    // Fetch all Role from the API with pagination and search
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getData(`/get-audit-log?page=${page}&limit=${rowsPerPage}&search=${debouncedSearchQuery}&roleId=${selectedRole}`);
            if (response) {
                setData(response.data);
                setTotalPages(response.totalPages);
            }
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch data', error);
            setLoading(false);
        }
    };

    const getRoleDropdown = async () => {
        try {

            const response = await getData("/get-role-dropdown");

            if (response) {
                setRoleData(response);
            }

        } catch (error) {
            console.error('Failed to fetch data', error);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1); // Reset to first page on new search
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(event.target.value);
        setPage(1);
    };

    return (
        <Layout>
            {loading ? <Progress /> :
                <Box className="p-6 bg-gray-100 min-h-screen">
                    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}>
                        Audit Log Details
                    </Typography>
                    {/* Header: Add Button (left) and Search (right) */}
                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }} >
                        <TextField placeholder="Search Role" value={searchQuery} onChange={handleSearchChange} variant="outlined" size="medium"
                            sx={{
                                width: 350, bgcolor: '#e9ecef', borderRadius: 2,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#757575' }} />
                                    </InputAdornment>
                                ),
                                sx: { bgcolor: '#e9ecef', borderRadius: 2 },
                            }}
                        />
                    </Box> */}


                    {/* Header: Add Button (left) and Search (right) */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }} >
                        <Box sx={{ display: "flex", gap: 2, alignItems: 'center' }}>
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                                <InputLabel>Role</InputLabel>
                                <Select
                                    value={selectedRole}
                                    label="College"
                                    onChange={(e) => {
                                        setSelectedRole(e.target.value);
                                        setPage(1);
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    {roleData.map((role) => (
                                        <MenuItem key={role._id} value={role._id}>
                                            {role.role_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        <TextField placeholder="Search" value={searchQuery} onChange={handleSearchChange} variant="outlined" size="medium"
                            sx={{ width: 350, bgcolor: '#e9ecef', borderRadius: 2, '& .MuiOutlinedInput-root': { borderRadius: 2, }, }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon sx={{ color: '#757575' }} />
                                    </InputAdornment>
                                ),
                                sx: { bgcolor: '#e9ecef', borderRadius: 2 },
                            }}
                        />


                    </Box>

                    {/* Table */}
                    {/* <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden', }} > */}

                    <TableContainer component={Paper}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            overflowX: "auto",
                            overflowY: "hidden",
                            "&::-webkit-scrollbar": {
                                height: "8px"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#888",
                                borderRadius: "4px"
                            }
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#4B49AC' }}>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}>
                                        ID
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                                        Page
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                                        Title
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                                        Create By
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                                        Ip Address
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}>
                                        Created At
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((item, index) => (
                                    <TableRow key={item._id}>
                                        <TableCell align="center">
                                            <Typography variant="body1">{(page - 1) * rowsPerPage + index + 1}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.action}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">
                                                {item.resource?.length > 50
                                                    ? item.resource.slice(0, 50) + "..."
                                                    : item.resource}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item?.user?.firstName}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.ipAddress}</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant="body1">{item.createdAt ? new Date(item.createdAt).toLocaleString() : item.createdAt}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Pagination */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Pagination count={totalPages} page={page} onChange={handlePageChange} shape="rounded"
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    '&.Mui-selected': {
                                        bgcolor: '#4B49AC',
                                        color: 'white',
                                    },
                                },
                            }}
                        />
                        <Select value={rowsPerPage} onChange={handleRowsPerPageChange} size="small"
                            sx={{ ml: 2, height: 35, bgcolor: '#f7f7f7', border: '1px solid #e2e2e2', '& .MuiSelect-select': { py: 0.75 }, }}
                            IconComponent={KeyboardArrowDownIcon} >
                            <MenuItem value={10}>10 / page</MenuItem>
                            <MenuItem value={20}>20 / page</MenuItem>
                            <MenuItem value={50}>50 / page</MenuItem>
                        </Select>
                    </Box>
                </Box>
            }
        </Layout>
    );
};

export default AuditLogDetails;